import React from 'react'
import HotelsForm from '@/components/Hotels/SearchForm/Form'
import FlightsForm from '@/components/Flights/SearchForm/Form'
import CarsForm from '@/components/Cars/SearchForm/Form'
import PackagesForm from '@/components/Packages/SearchForm/Form'
import CruisesForm from '@/components/Cruises/SearchForm/Form'
import { onSubmit as onSubmitVP } from '@/components/Packages/SearchForm/utils'
import { handleSubmitForCars } from '@/components/Cars/SearchForm/utils'
import { onSubmit as onSubmitFlight } from '@/components/Flights/SearchForm/utils'
import { handleSubmitForHotels } from '@/components/Hotels/SearchForm/utils'
import { LOCATION_SEARCH_TYPE } from '@/types'

import {
  CarsBumper,
  CruiseBumper,
  FlightsBumper,
  HotelsBumper,
  VacationBumper
} from '../Bumpers'

type MobileHeadlineType = {
  mobileHeadline: string
}

type SearchFormProductHeadlineType = {
  hotels: MobileHeadlineType
  flights: MobileHeadlineType
  vacations: MobileHeadlineType
  cars: MobileHeadlineType
  cruises: MobileHeadlineType
}

const getProductCategoryMobileExperiment = (
  productType: string,
  values: SearchFormProductHeadlineType,
  setLocation: (key: LOCATION_SEARCH_TYPE | undefined) => void
) => {
  switch (productType) {
    case 'flights':
      return {
        component: <FlightsForm onSubmit={onSubmitFlight} />,
        bumper: <FlightsBumper />
      }
    case 'cars':
      return {
        component: <CarsForm onSubmit={handleSubmitForCars} />,
        bumper: <CarsBumper />
      }
    case 'vacations':
      return {
        component: <PackagesForm onSubmit={onSubmitVP} isLandingPage={false} />,
        bumper: <VacationBumper />
      }

    case 'cruises':
      return {
        component: <CruisesForm />,
        bumper: <CruiseBumper />
      }

    default:
      return {
        component: (
          <HotelsForm
            onSubmit={handleSubmitForHotels}
            setLocation={setLocation}
          />
        ),
        bumper: <HotelsBumper />,
        headline: values.hotels.mobileHeadline
      }
  }
}

export default getProductCategoryMobileExperiment
